import type { CameraMode } from '../types'

export interface HudApi {
  setMode: (mode: CameraMode) => void
  setProgress: (found: number, total: number) => void
  setHint: (text: string) => void
  setTrailStatus: (text: string) => void
  setJourney: (playerLabel: string, journeyTitle: string) => void
  setAtlasActive: (active: boolean) => void
  /** Names the nearest point of interest, or clears the prompt with null. */
  setPoiPrompt: (label: string | null) => void
  setFlightAvailable: (available: boolean) => void
  flash: (text: string) => void
  shutter: () => void
}

export function bindHud(handlers: {
  onMode: (mode: CameraMode) => void
  onOverview: () => void
  onNorth: () => void
  onTop: () => void
  onPlayer: () => void
  onTrail: () => void
  onAtlas: () => void
  onPoiPrompt: () => void
  onGolden: () => void
  onPhoto: () => void
  onShare: () => void
  onAudio: () => void
  onMapData: () => boolean
}): HudApi {
  const modeExplore = document.querySelector<HTMLButtonElement>('#mode-explore')!
  const modeWalk = document.querySelector<HTMLButtonElement>('#mode-walk')!
  const modeFlight = document.querySelector<HTMLButtonElement>('#mode-flight')!
  const btnOverview = document.querySelector<HTMLButtonElement>('#btn-overview')!
  const btnNorth = document.querySelector<HTMLButtonElement>('#btn-north')!
  const btnTop = document.querySelector<HTMLButtonElement>('#btn-top')!
  const btnPlayer = document.querySelector<HTMLButtonElement>('#btn-player')!
  const btnTrail = document.querySelector<HTMLButtonElement>('#btn-trail')!
  const btnAtlas = document.querySelector<HTMLButtonElement>('#btn-atlas')!
  const btnGolden = document.querySelector<HTMLButtonElement>('#btn-golden')!
  const btnPhoto = document.querySelector<HTMLButtonElement>('#btn-photo')!
  const btnShare = document.querySelector<HTMLButtonElement>('#btn-share')!
  const btnAudio = document.querySelector<HTMLButtonElement>('#btn-audio')!
  const btnMapData = document.querySelector<HTMLButtonElement>('#btn-map-data')!
  const progress = document.querySelector<HTMLElement>('#discover-progress')!
  const hint = document.querySelector<HTMLElement>('#hint-text')!
  const trailStatus = document.querySelector<HTMLElement>('#trail-status')!
  const toast = document.querySelector<HTMLElement>('#toast')!
  const brandPlace = document.querySelector<HTMLElement>('.brand-place')!
  const poiPrompt = document.querySelector<HTMLButtonElement>('#poi-prompt')!
  const poiPromptLabel = document.querySelector<HTMLElement>('#poi-prompt-label')!

  const setActive = (mode: CameraMode) => {
    modeExplore.classList.toggle('active', mode === 'explore')
    modeWalk.classList.toggle('active', mode === 'walk' || mode === 'trail')
    modeFlight.classList.toggle('active', mode === 'flight')
    btnTrail.classList.toggle('active', mode === 'trail')
  }

  modeExplore.addEventListener('click', () => handlers.onMode('explore'))
  modeWalk.addEventListener('click', () => handlers.onMode('walk'))
  modeFlight.addEventListener('click', () => handlers.onMode('flight'))
  btnOverview.addEventListener('click', () => handlers.onOverview())
  btnNorth.addEventListener('click', () => handlers.onNorth())
  btnTop.addEventListener('click', () => handlers.onTop())
  btnPlayer.addEventListener('click', () => handlers.onPlayer())
  btnTrail.addEventListener('click', () => handlers.onTrail())
  btnAtlas.addEventListener('click', () => handlers.onAtlas())
  poiPrompt.addEventListener('click', () => handlers.onPoiPrompt())
  btnGolden.addEventListener('click', () => handlers.onGolden())
  btnPhoto.addEventListener('click', () => handlers.onPhoto())
  btnShare.addEventListener('click', () => handlers.onShare())
  btnAudio.addEventListener('click', () => handlers.onAudio())
  btnMapData.addEventListener('click', () => {
    const enabled = handlers.onMapData()
    btnMapData.classList.toggle('active', enabled)
  })

  let toastTimer = 0
  const flash = (text: string) => {
    toast.textContent = text
    toast.classList.add('show')
    window.clearTimeout(toastTimer)
    toastTimer = window.setTimeout(() => toast.classList.remove('show'), 2400)
  }

  const shutterEl = document.querySelector<HTMLElement>('#shutter')!
  const shutter = () => {
    shutterEl.classList.remove('fire')
    // Force a reflow so the animation restarts on rapid repeat shots.
    void shutterEl.offsetWidth
    shutterEl.classList.add('fire')
  }

  return {
    setMode: setActive,
    setProgress: (found, total) => {
      progress.textContent = `Discovered ${found} / ${total}`
      progress.style.setProperty('--pct', `${total ? (found / total) * 100 : 0}%`)
    },
    setHint: (text) => {
      hint.textContent = text
    },
    setTrailStatus: (text) => {
      trailStatus.textContent = text
    },
    setJourney: (_playerLabel, _journeyTitle) => {
      brandPlace.textContent = 'Land of Fire'
      btnPlayer.hidden = true
      btnTrail.hidden = true
    },
    setAtlasActive: (active) => {
      btnAtlas.classList.toggle('active', active)
    },
    setPoiPrompt: (label) => {
      poiPrompt.classList.toggle('hidden', label === null)
      if (label !== null) poiPromptLabel.textContent = label
    },
    setFlightAvailable: (available) => {
      modeFlight.hidden = !available
      if (!available && modeFlight.classList.contains('active')) {
        handlers.onMode('explore')
      }
    },
    flash,
    shutter,
  }
}
